import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import _request from "actions/_request";
import i18n from "i18";

import "./style.css";

const StripeSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const params = Object.fromEntries(searchParams.entries());
    _request.stripe.success(params).catch(() => {});
  }, [searchParams]);

  const tr = (key) => i18n.t("stripe." + key);

  return (
    <Box className="flex flex1 centerH centerV">
      <Box className="stripe-result-card">
        <CheckCircleOutlineIcon className="stripe-result-icon stripe-result-icon--success" />

        <Typography className="stripe-result-title">
          {tr("successTitle")}
        </Typography>

        <Typography className="stripe-result-desc">
          {tr("successDesc")}
        </Typography>

        <Box className="stripe-result-actions">
          <Box
            className="stripe-result-btn stripe-result-btn--primary"
            onClick={() => navigate("/app/dashboard")}>
            {tr("goDashboard")}
          </Box>
          <Box
            className="stripe-result-btn stripe-result-btn--secondary"
            onClick={() => navigate("/app/pricing")}>
            {tr("viewPricing")}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StripeSuccess;
